import { SalesSites } from './sales-sites.component.js';

export * from './sales-sites.component.js';
export default SalesSites;

SalesSites.define('der-tailormade-offer-request-sales-sites');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-offer-request-sales-sites': SalesSites;
    }
}
